import { render } from "./ent_prescriptions.vue?vue&type=template&id=cd8eac68&scoped=true"
import script from "./ent_prescriptions.vue?vue&type=script&lang=js"
export * from "./ent_prescriptions.vue?vue&type=script&lang=js"

import "./ent_prescriptions.vue?vue&type=style&index=0&id=cd8eac68&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd8eac68"]])

export default __exports__